// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #e0e0e0;
  height: 100%;
}

.upload-note {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 5px;
  text-align: center;
}

.image-container {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  border: 1px dashed #ced4da;
  margin-bottom: 10px;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-label {
  font-weight: 600;
  color: #333;
  font-size: 1.1rem;
  margin-bottom: 15px;
  text-align: center;
}

.file-upload-wrapper {
  position: relative;
  width: 100%;
  margin-top: auto;
}

.file-upload-input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.file-upload-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 15px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-radius: 5px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s;
}

.file-upload-label:hover {
  background-color: #e9ecef;
}

.file-upload-label svg {
  font-size: 1.2rem;
}

.btn-primary {
  padding: 8px 25px;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .upload-card {
      padding: 15px;
  }
  
  .image-container {
      height: 100px;
  }
}

.uploaded-file-name {
  color: #28a745;
  font-size: 0.8rem;
  text-align: center;
  word-break: break-all;
  padding: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/UserImageUploads.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;MACI,aAAa;EACjB;;EAEA;MACI,aAAa;EACjB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".upload-card {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid #e0e0e0;\n  height: 100%;\n}\n\n.upload-note {\n  color: #666;\n  font-size: 0.9rem;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n.image-container {\n  width: 100%;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px dashed #ced4da;\n  margin-bottom: 10px;\n}\n\n.preview-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.image-label {\n  font-weight: 600;\n  color: #333;\n  font-size: 1.1rem;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.file-upload-wrapper {\n  position: relative;\n  width: 100%;\n  margin-top: auto;\n}\n\n.file-upload-input {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.file-upload-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 8px 15px;\n  background-color: #f8f9fa;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.file-upload-label:hover {\n  background-color: #e9ecef;\n}\n\n.file-upload-label svg {\n  font-size: 1.2rem;\n}\n\n.btn-primary {\n  padding: 8px 25px;\n  font-weight: 500;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .upload-card {\n      padding: 15px;\n  }\n  \n  .image-container {\n      height: 100px;\n  }\n}\n\n.uploaded-file-name {\n  color: #28a745;\n  font-size: 0.8rem;\n  text-align: center;\n  word-break: break-all;\n  padding: 0 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
